var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBussIconGlobalRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 60 60",
    style: {
      enableBackground: "new 0 0 60 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;opacity:0.2;}\n\t.st2{fill:#808080;}\n\t.st3{fill:url(#SVGID_1_);}\n\t.st4{display:inline;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linejoin:round;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st7{display:inline;fill:#112E47;stroke:#FFFFFF;stroke-width:1.4;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st9{fill:#112E47;stroke:#FFFFFF;stroke-width:1.8;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#112E47;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{display:inline;fill:#FFFFFF;stroke:#FFFFFF;stroke-width:1.4;stroke-miterlimit:10;}\n\t.st12{fill:none;stroke:#112E47;stroke-width:3;stroke-linejoin:round;}\n\t.st13{fill:none;stroke:#112E47;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st14{display:inline;fill:#112E47;stroke:#112E47;stroke-width:1.4;stroke-miterlimit:10;}\n\t.st15{fill:#112E47;stroke:#112E47;stroke-width:1.8;stroke-miterlimit:10;}\n\t.st16{fill:#36464C;stroke:#000000;stroke-width:3;stroke-linejoin:round;}\n\t.st17{fill:none;stroke:#000000;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st18{fill:none;stroke:#112E47;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,0,0,4;}\n\t.st19{fill:#80CCF3;stroke:#80CCF3;stroke-width:3;stroke-linejoin:round;}\n\t.st20{fill:none;stroke:#009AE7;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st21{fill:none;stroke:#80CCF3;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n\t.st22{fill:none;stroke:#80CCF3;stroke-width:3;stroke-linejoin:round;}\n\t.st23{fill:none;stroke:#009AE7;stroke-width:3;stroke-linejoin:round;}\n\t.st24{fill:none;stroke:#80CCF3;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0,0,0,4;}\n\t.st25{fill:none;stroke:#80CCF3;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st26{fill:none;stroke:#009AE7;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st27{fill:#009AE7;}\n\t.st28{fill:none;stroke:#009AE7;stroke-width:2;stroke-miterlimit:10;}\n\t.st29{fill:none;stroke:#009AE7;stroke-width:2.5;stroke-linejoin:round;}\n\t.st30{fill:none;stroke:#80CCF3;stroke-width:2.5;stroke-linecap:round;stroke-linejoin:round;}\n\t.st31{fill:none;stroke:#009AE7;stroke-width:2.8;stroke-linejoin:round;}\n\t.st32{fill:none;stroke:#009AE7;stroke-width:3;stroke-miterlimit:10;}\n\t.st33{fill:#80CCF3;}\n\t.st34{fill:#FFFFFF;}\n\t.st35{fill:#112E47;}\n\t.st36{fill:#36464C;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Konturen",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st25",
    cx: 30,
    cy: 30,
    rx: 11.5,
    ry: 25
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M50.9,16.7c-4.4,2.2-12.1,3.7-20.9,3.7c-8.9,0-16.7-1.5-21.1-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M8.9,43.5c4.4-2.2,12.1-3.7,20.9-3.7c8.9,0,16.7,1.5,21.1,3.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 30,
    y1: 5.5,
    x2: 30,
    y2: 54.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 54.5,
    y1: 30,
    x2: 5.5,
    y2: 30
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st26",
    cx: 30,
    cy: 30,
    r: 25
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Fl\\xE4chen"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M30,56.5c-7.3,0-13-11.6-13-26.5S22.7,3.5,30,3.5S43,15.1,43,30S37.3,56.5,30,56.5z M30,6.5 c-4.8,0-10,9.4-10,23.5s5.2,23.5,10,23.5S40,44.1,40,30S34.8,6.5,30,6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M30,21.9c-8.9,0-17-1.5-21.7-3.9c-0.7-0.4-1-1.3-0.6-2c0.4-0.7,1.3-1,2-0.6c4.3,2.2,12.1,3.6,20.4,3.6 c8.2,0,16-1.3,20.3-3.5c0.7-0.4,1.6-0.1,2,0.7c0.4,0.7,0.1,1.6-0.7,2C46.9,20.4,38.8,21.9,30,21.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M50.9,45c-0.2,0-0.5-0.1-0.7-0.2c-4.3-2.2-12.1-3.6-20.4-3.6c-8.2,0-16,1.3-20.3,3.5c-0.7,0.4-1.6,0.1-2-0.7 c-0.4-0.7-0.1-1.6,0.7-2c4.7-2.4,12.8-3.8,21.6-3.8c8.9,0,17,1.5,21.7,3.9c0.7,0.4,1,1.3,0.6,2C52,44.8,51.5,45,50.9,45z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M30,56c-0.8,0-1.5-0.7-1.5-1.5v-49C28.5,4.7,29.2,4,30,4s1.5,0.7,1.5,1.5v49C31.5,55.3,30.8,56,30,56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M54.5,31.5h-49C4.7,31.5,4,30.8,4,30s0.7-1.5,1.5-1.5h49c0.8,0,1.5,0.7,1.5,1.5S55.3,31.5,54.5,31.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M30,56.5C15.4,56.5,3.5,44.6,3.5,30S15.4,3.5,30,3.5S56.5,15.4,56.5,30S44.6,56.5,30,56.5z M30,6.5 C17,6.5,6.5,17,6.5,30S17,53.5,30,53.5S53.5,43,53.5,30S43,6.5,30,6.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBussIconGlobalRgb);
export default __webpack_public_path__ + "static/media/buss_icon_global_rgb.a3c46e1295058c70501e1fe73fae7e21.svg";
export { ForwardRef as ReactComponent };